import { render, staticRenderFns } from "./InboxMailDetail.vue?vue&type=template&id=6c6b993d&scoped=true"
import script from "./InboxMailDetail.vue?vue&type=script&lang=js"
export * from "./InboxMailDetail.vue?vue&type=script&lang=js"
import style0 from "./InboxMailDetail.vue?vue&type=style&index=0&id=6c6b993d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b993d",
  null
  
)

export default component.exports